import { FC, useEffect, useRef } from 'react';
import { toast } from 'react-toastify';
interface ErrorMessageProps {
    error: string;
}
const ErrorMessage: FC<ErrorMessageProps> = ({ error }) => {
    const lastError = useRef<string>('');
    useEffect(() => {
        if (error && error !== lastError.current) {
            toast.error(error);
            lastError.current = error;
        }
        if (!error) {
            lastError.current = '';
        }
    }, [error]);
    return null;
};
export default ErrorMessage;
